import { FilterState } from '../store';

interface TransformFiltersProps {
    filterName: string; // key that is displayed within the url
    minValue: number | null;
    maxValue: number | null;
    stringValues: Array<string> | null;
}

export const transformFilters = (items: FilterState) => {
    const transformedFilters: TransformFiltersProps[] = [];

    Object.keys(items).forEach(key => {
        const filterName = key as keyof typeof items;
        const { hasRangeValues, inputs } = items[filterName];
        const filterInputs = inputs.filter(input => input.checked);

        if (hasRangeValues) {
            transformedFilters.push({
                filterName: filterName as string,
                stringValues: null,
                minValue: filterInputs.length > 0 ? parseInt(filterInputs[0].value) : null,
                maxValue: filterInputs.length > 1 ? parseInt(filterInputs[1].value) : null,
            });
        } else {
            transformedFilters.push({
                filterName: filterName as string,
                stringValues: filterInputs.map(input => input.value),
                minValue: null,
                maxValue: null,
            });
        }
    });

    return transformedFilters.filter(transformFiltersHasValues);
};

/**
 * Check if the a transformed value has any values otherwise we do not sent it.
 * @param {TransformFiltersProps} item
 * @returns { boolean }
 */
function transformFiltersHasValues(item: TransformFiltersProps) {
    return (item.stringValues && item.stringValues.length > 0) || item.minValue || item.maxValue;
}
